import { suiNSNamesModel } from '@models/sui-ns-names.model';
import { useResolveSuiNSName } from '@mysten/dapp-kit';
import { useModel } from 'foca';
import { useEffect } from 'react';

export const useSuiNSName = (address: string) => {
  const suiNsNames = useModel(suiNSNamesModel, (state) => state[address]);
  const shouldFetch = suiNsNames === undefined;

  const suiNames = useResolveSuiNSName(shouldFetch ? address : null);

  useEffect(() => {
    if (shouldFetch && suiNames.data) {
      suiNSNamesModel.updateNs(address, suiNames.data);
    }
  }, [shouldFetch, suiNames.data]);

  return suiNsNames?.name;
};
